import { compact, flatMap } from 'lodash';
import RemindAPI from 'lib/RemindAPI';
import { stripTypename } from '../utils';

import { LanguageSetInput } from 'globalTypes';
import { ActionResponse, DefaultActionError, DEFAULT_ACTION_ERROR } from 'translations/types';

import GET_LANGUAGE_SET_QUERY from '../queries/GetLanguageSetQuery.gql';
import {
  GetLanguageSet,
  GetLanguageSetVariables,
  GetLanguageSet_translations_getLanguageSet_data_languageCounts as LanguageCounts,
} from 'translations/queries/__generated__/GetLanguageSet';

export async function getLanguageSets(
  input: LanguageSetInput[]
): Promise<ActionResponse<{ items: LanguageCounts[] }, DefaultActionError>> {
  const { translations: resp } = await RemindAPI.execute<GetLanguageSet, GetLanguageSetVariables>({
    query: GET_LANGUAGE_SET_QUERY,
    variables: { input },
    forceFetch: true,
  });

  const data = resp?.getLanguageSet?.data;
  const error = resp?.getLanguageSet?.error;
  if (error || !data || !data.length) {
    return {
      success: false,
      ...(error ? stripTypename(error) : DEFAULT_ACTION_ERROR),
    };
  } else {
    const results = compact(
      flatMap(data, countsForTarget => {
        return countsForTarget.languageCounts;
      })
    );

    return { success: true, items: results };
  }
}
